import { render, staticRenderFns } from "./tabCamera.vue?vue&type=template&id=bc5cddfa&scoped=true"
import script from "./tabCamera.vue?vue&type=script&lang=js"
export * from "./tabCamera.vue?vue&type=script&lang=js"
import style0 from "./tabCamera.vue?vue&type=style&index=0&id=bc5cddfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5cddfa",
  null
  
)

export default component.exports